export enum PAYMENT_METHOD_IDS {
  BONUS_CARD = 'BONUS_CARD',
  GIFT_CERTIFICATE = 'GIFT_CERTIFICATE',
  BT_CREDIT_CARD = 'BT_CREDIT_CARD',
  CREDIT_CARD = 'CREDIT_CARD',
  PAYPAL = 'PayPal',
  GOOGLE_PAY = 'GooglePay',
  APPLE_PAY = 'ApplePay'
}

export enum CARD_TYPES {
  AMERICAN_EXPRESS = 'amex',
  VISA = 'Visa',
  DISCOVER = 'Discover',
  MASTERCARD = 'MasterCard',
  PAYPAL = 'PayPal',
  GENERIC = 'Generic',
  CREDIT_CARD = 'Credit / Debit Card',
  BONUS_CARD = 'Bonus Card',
  GIFT_CERTIFICATE = 'Gift Certificate',
  GOOGLE_PAY = 'Google Pay',
  APPLE_PAY = 'Apple Pay'
}
export type CARD_TYPES_CODE = `${CARD_TYPES}`

export const CARD_TYPES_NAMES = {
  [CARD_TYPES.AMERICAN_EXPRESS]: 'Amex',
  [CARD_TYPES.VISA]: 'Visa',
  [CARD_TYPES.DISCOVER]: 'Discover',
  [CARD_TYPES.MASTERCARD]: 'MasterCard',
} as const

export const CreditCardValidatorTypesMap = {
  mastercard: CARD_TYPES.MASTERCARD,
  'american-express': CARD_TYPES.AMERICAN_EXPRESS,
  visa: CARD_TYPES.VISA,
  discover: CARD_TYPES.DISCOVER,
}

export const SupportedApplePayVersion = 3
export const applePayScript = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js'